import React from 'react'
import { Card, Form, InputGroup, Button } from 'react-bootstrap'
import { TextInput } from '../../atoms/TextInput'

interface UnitsSearchProps {
  searchTerm: string
  onSearchChange: (searchTerm: string) => void
  resultsCount?: number
  totalCount?: number
}

export const UnitsSearch: React.FC<UnitsSearchProps> = ({
  searchTerm,
  onSearchChange,
  resultsCount = 0,
  totalCount = 0
}) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value)
  }

  const handleClearSearch = () => {
    onSearchChange('')
  }

  return (
    <Card.Body>
      <h6 className="mb-3">🔍 Buscar Unidades</h6>
      <Form>
        <Form.Group>
          <Form.Label>Pesquisar por:</Form.Label>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Nome da unidade, edifício ou projeto..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {searchTerm && (
              <InputGroup.Append>
                <Button
                  variant="outline-secondary"
                  onClick={handleClearSearch}
                  title="Limpar busca"
                >
                  ✕
                </Button>
              </InputGroup.Append>
            )}
          </InputGroup>
          <Form.Text className="text-muted">
            {searchTerm ? (
              <div>
                <span className="text-info">
                  🔎 Buscando por: &quot;{searchTerm}&quot;
                </span>
                <br />
                <span className="text-success">
                  📊 {resultsCount} de {totalCount} unidades encontradas
                </span>
              </div>
            ) : (
              <span>
                Busque por nome da unidade, edifício ou projeto
                {totalCount > 0 && (
                  <span className="text-muted">
                    {' '}
                    ({totalCount} unidades disponíveis)
                  </span>
                )}
              </span>
            )}
          </Form.Text>
        </Form.Group>
      </Form>
    </Card.Body>
  )
}
